import merge from 'lodash/merge'
import cloneDeep from 'lodash/cloneDeep'

import { BaseChartController } from './base_chart_component_controller'

export class PieChartController extends BaseChartController {
  static values = merge(cloneDeep(BaseChartController.values), {
    series: Object,
    radius: { type: Number, default: 70 }
  })

  options () {
    let borderColor = '#fff'
    if (this.pdfValue) {
      this.legendTypeValue = 'left'
      borderColor = '#f2f2f2'
    }

    return merge(super.options(), {
      series: {
        itemStyle: {
          borderRadius: 5,
          borderColor,
          borderWidth: 2
        },
        left: this.legendTypeValue === 'left' ? 160 : 0,
        right: this.legendTypeValue === 'vertical' ? 115 : 0,
        type: 'pie',
        radius: `${this.radiusValue}%`,
        center: [this.legendTypeValue === 'vertical' ? `${this.radiusValue / 2 + 4}%` : '50%', this.legendTypeValue === 'horizontal' ? `${this.radiusValue / 2 + 2}%` : '50%'],
        avoidLabelOverlap: true,
        label: {
          show: this.legendTypeValue === 'none',
          position: this.legendTypeValue === 'none' ? 'outer' : 'center'
        },
        data: this.transformToSeriesData(this.seriesValue)
      }
    })
  }

  transformToSeriesData (series) {
    return Array.from(Object.entries(series).map(([name, value]) => {
      return {
        name,
        value
      }
    }))
  }

  tooltipOptions () {
    return merge(super.tooltipOptions(), {
      formatter: null
    })
  }

  legendOptions () {
    const data = this.transformToSeriesData(this.seriesValue)
    const valueFormatter = this.tooltipOptions().valueFormatter

    return merge(super.legendOptions(), {
      left: merge(super.legendOptions().left, {
        formatter: (name) => {
          let value = data.filter(row => row.name === name)[0].value
          if (valueFormatter !== undefined) {
            value = valueFormatter(value)
          }
          return `${name}\n{bold|${value}}`
        },
        textStyle: {
          rich: {
            bold: {
              fontWeight: 700,
              lineHeight: 26
            }
          }
        }
      })
    })
  }
}

export default PieChartController
